module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_eukaryotic_chromosome_2-a101d625d5f6a696473830c530b6f2db.jpg";